import React, { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import SelectParty from "components/party/components/SelectParty";
import {setAddOrderStoryState} from "store/slice/AppSlice";
import {setProductDashboardProductList, setPharmaorderManageProductsModal} from "store/slice/PharmaSlice";
import { canOrderBeCreatedAPI } from "api/OmsOrdermgmtWebServices";
import {setErrMsg, clearErrMsg} from "store/slice/AppSlice";
import { setSelectedProductId, setSelectedCompositiontemplateId } from "store/slice/PharmaSlice";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PharmaorderDashboard from "components/pharmaorder/PharmaorderDashboard";
import ProductDashboard from "components/product/ProductDashboard";
import { setPharmaorderSubmitorderModal } from "store/slice/PharmaSlice";

export default function AddOrderProductDashboard() {
  const dispatch = useDispatch()
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const {productList} = useSelector((state) => state.pharmaslice.productDashboard);
  const { productDashboard } = useSelector((state) => state.pharmaslice);
  const {showEdit} = useSelector((state) => state.pharmaslice.productDashboard);

  useEffect(() => {
    dispatch(
      setProductDashboardProductList(
            productList.filter(obj => obj.orderid == pharmaorderObj.id)
    ))
  },[]);
  
  const handleSubmitOrder = () => {
          dispatch(setPharmaorderSubmitorderModal(true));
  }
  return (
    <>
      <ProductDashboard/>
      {!showEdit &&
      <Grid lg={12} xs={12} item sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%", mt: 2 }}>
        <Button
            variant="contained"
              onClick={() => handleSubmitOrder()}
              disabled={productDashboard.productList.length==0}
            sx={{
                '&.Mui-disabled': {
                    backgroundColor: 'secondary.400',
                    color: 'primary.contrastText',
                    opacity: 1,
                },
            }}
        >
            Submit for Approval
        </Button>
    </Grid>
    }
    </>
  );
}